module.exports = __webpack_public_path__ + "static/media/2playerRoomsPlayed_75000_100000.0d1e7818.png";